import { Text } from "~/components/Text";

type Props = {
  className?: string;
};

export function CheckoutTerms({ className = "mt-5" }: Props) {
  return (
    <Text size="xs" className={`${className} text-center`}>
      By checking out, you agree to Butter&rsquo;s{" "}
      <a
        href="https://www.joinbutter.co/terms-conditions"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Terms of Service
      </a>{" "}
      &amp;{" "}
      <a
        href="https://www.joinbutter.co/refund-policy"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Refund Policy.
      </a>
    </Text>
  );
}
